export const voteTransactionKeys = {
    user: (userId: string) => ["vote-transactions", userId] as const,
};
